import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';

const state = {
    subscription_info: {},
    subscription_detail: {},
    subscription_records: [],
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
